import { useCallback, useState, useLayoutEffect } from 'react'

function getSize(el) {
    if (!el) {
        return {
            width: 0,
            height: 0,
            visibleWidth: 0,
            visibleHeight: 0
        }
    }

    return {
        width: el.offsetWidth,
        height: el.offsetHeight,

        visibleWidth: el.scrollWidth,
        visibleHeight: el.scrollHeight
    }
}

function useComponentSize(ref) {
    const [ComponentSize, setComponentSize] = useState(getSize(ref ? ref.current : {}))

    const handleResize = useCallback(() => {
        if (ref.current) {
            setComponentSize(getSize(ref.current))
        }
    }, [ref])

    useLayoutEffect(() => {
        if (!ref.current) {
            return
        }

        handleResize()

        // @ts-ignore
        if (typeof ResizeObserver === 'function') {
            // @ts-ignore
            let resizeObserver = new ResizeObserver(() => handleResize())
            resizeObserver.observe(ref.current)

            return () => {
                resizeObserver.disconnect(ref.current)
                resizeObserver = null
            }
        } else {
            window.addEventListener('resize', handleResize)

            return () => {
                window.removeEventListener('resize', handleResize)
            }
        }
    }, [ref.current])

    return ComponentSize
}

export { useComponentSize }
